import { jsx } from "react/jsx-runtime";
import MRadio from "@mui/material/Radio";
import styled from "@mui/material/styles/styled";
import THEME from "../../theme";
var ERadioSize = /* @__PURE__ */ ((ERadioSize2) => {
  ERadioSize2["S"] = "s";
  ERadioSize2["M"] = "m";
  return ERadioSize2;
})(ERadioSize || {});
const {
  borderRadius: BORDER_RADIUS = 50,
  size: {
    m: RADIO_SIZE_M = 24,
    s: RADIO_SIZE_S = 20,
    content: {
      m: CONTENT_SIZE_M = 8,
      s: CONTENT_SIZE_S = 6
    }
  },
  typography: {
    m: TYPOGRAPHY_SIZE_M = "body2",
    s: TYPOGRAPHY_SIZE_S = "body1"
  }
} = THEME.radio || {};
const BpIcon = styled("span")(({ size, theme, disabled }) => {
  const palette = theme.palette;
  const borderColor = palette.dionCommon.additional;
  const hoverBorderColor = palette.brand.main;
  const disabledBgColor = palette.dionCommon.disable;
  return {
    borderRadius: `${BORDER_RADIUS}%`,
    width: `${size}px`,
    height: `${size}px`,
    boxShadow: `0 0 0 1px ${borderColor}`,
    ...!disabled && {
      "input:hover ~ &": {
        boxShadow: `0 0 0 1px ${hoverBorderColor}`
      }
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      backgroundColor: disabledBgColor
    }
  };
});
const BpCheckedIcon = styled(BpIcon)(({ size, theme, innerCircleSize, disabled }) => {
  const palette = theme.palette;
  const checkedBgColor = palette.brand.main;
  const hoverBgColor = palette.brand.hover;
  const innerCircleColorLight = palette.static.light;
  const disabledInnerCircleColor = palette.dionCommon.transparent;
  const innerCircleColor = disabled ? disabledInnerCircleColor : innerCircleColorLight;
  return {
    backgroundColor: checkedBgColor,
    "&::before": {
      display: "block",
      width: `${size}px`,
      height: `${size}px`,
      backgroundImage: `radial-gradient(${innerCircleColor},${innerCircleColor} ${innerCircleSize}%,transparent ${innerCircleSize}%)`,
      content: '""',
      position: "absolute",
      zIndex: 1
    },
    ...!disabled && {
      "&:hover::after": {
        borderRadius: BORDER_RADIUS,
        content: '""',
        display: "block",
        width: `${size}px`,
        height: `${size}px`,
        backgroundColor: hoverBgColor,
        position: "absolute",
        zIndex: 2
      }
    }
  };
});
const CustomRadio = styled(MRadio)(({ size }) => ({
  width: `${size}px`,
  height: `${size}px`,
  padding: 0
}));
const Radio = (props) => {
  const { size, disabled } = props;
  const radioSize = THEME.radio.size[size];
  const innerCircleSize = Math.round(THEME.radio.size.content[size] / THEME.radio.size[size] * 100);
  return /* @__PURE__ */ jsx(
    CustomRadio,
    {
      disableRipple: true,
      color: "default",
      size: radioSize,
      disabled,
      checkedIcon: /* @__PURE__ */ jsx(
        BpCheckedIcon,
        {
          size: radioSize,
          innerCircleSize,
          disabled
        }
      ),
      icon: /* @__PURE__ */ jsx(
        BpIcon,
        {
          size: radioSize,
          disabled
        }
      ),
      ...props
    }
  );
};
var Radio_default = Radio;
export {
  ERadioSize,
  Radio_default as default
};
